<template>
  <div class="ma-editor-wraper">
    <editor
      v-model="content"
      :init="config"
    ></editor>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { postFile } from '@/api/api-upload'
import { getGetFileUrl } from '@/utils/fileserver.js'

// 当弹出文件选择框时的回调方法
// function filePickerCallback (callback, value, meta) {
//   alert('filePickerCallback')
//   return true
// }

// 处理文件上传时的回调方法
function imagesUploadHandler (blobInfo, success, failure) {
  // alert('imagesUploadHandler')
  const fileName = blobInfo.filename()
  const genericErrorText = `Couldn't upload file: ${fileName}.`
  const formData = new FormData()
  formData.append('file', blobInfo.blob(), blobInfo.filename())
  formData.append('dir', '/tinyMCE/editor-image/')

  postFile(formData)
    .then(response => {
      const uploadRS = response.data
      if (!response || response.success === false) {
        failure(response && response.errorCode ? `${genericErrorText} ${response.errorCode}:${response.errorMessage}` : genericErrorText)
      }
      console.debug(`ckeditor upload success: ${fileName}`)
      success(`${getGetFileUrl()}${uploadRS.path}`)
    })
    .catch(error => {
      failure(error)
    })
}

// 文本编辑器默认配置
const defaultConfig = {
  language: 'en_US',
  language_url: 'https://signettours.com/web-public/tinymce/langs/zh_CN.js',
  height: 360,
  resize: false,
  convert_urls: false,
  element_format: 'html',
  // file_picker_callback: filePickerCallback,
  images_upload_handler: imagesUploadHandler,
  // autosave_ask_before_unload: false,
  // powerpaste_allow_local_images: true,
  plugins: [
    'advlist anchor autolink charmap fullscreen help image imagetools',
    ' lists link media noneditable preview',
    ' searchreplace table template visualblocks wordcount emoticons'
  ], /* advcode colorpicker textcolor a11ychecker removed: insertdatetime print codesample powerpaste tinymcespellchecker mentions formatpainter */
  templates: [
    // {
    //   title: '飞机小图标',
    //   description: '飞机',
    //   content: '<img src="http://signettours.cn/mob/static/images/trip/fj.png" style="width:11px;margin: 0 5px;">'
    // },
    // {
    //   title: '船小图标',
    //   description: '船',
    //   content: '<img src="http://signettours.cn/mob/static/images/trip/chuan.png" style="width:11px;margin: 0 5px;">'
    // },
    // {
    //   title: '汽车小图标',
    //   description: '汽车',
    //   content: '<img src="http://signettours.cn/mob/static/images/trip/qc.png" style="width:11px;margin: 0 5px;">'
    // }
  ],
  font_formats: '微软雅黑=微软雅黑;宋体=宋体;黑体=黑体;仿宋=仿宋;楷体=楷体;隶书=隶书;幼圆=幼圆;andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
  toolbar:
    'myicons | formatselect | fontselect | undo redo | bold italic strikethrough formatpainter | forecolor backcolor | template codesample | alignleft aligncenter alignright alignjustify | bullist numlist | link image removeformat',
  // remove a11ycheck insertfile fontsizeselect fontselect
  content_css: [
    '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i'
    // '//www.tiny.cloud/css/content-standard.min.css'
  ],
  spellchecker_dialog: true,
  spellchecker_whitelist: ['Ephox', 'Moxiecode'],
  // eslint-disable-next-line
  setup (editor) {
    // editor.ui.registry.addIcon('myicon-flight', '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>')
    // editor.ui.registry.addMenuButton('myicons', {
    //   text: '小图标',
    //   fetch (callback) {
    //     var items = [
    //       {
    //         type: 'menuitem',
    //         text: '飞机',
    //         onAction: function () {
    //           editor.insertContent('<img src="http://signettours.cn/mob/static/images/trip/fj.png" style="width:11px;margin: 0 5px;">')
    //         }
    //       },
    //       {
    //         type: 'menuitem',
    //         text: '汽车',
    //         onAction: function () {
    //           editor.insertContent('<img src="http://signettours.cn/mob/static/images/trip/qc.png" style="width:11px;margin: 0 5px;">')
    //         }
    //       },
    //       {
    //         type: 'menuitem',
    //         text: '轮船',
    //         onAction: function () {
    //           editor.insertContent('<img src="http://signettours.cn/mob/static/images/trip/chuan.png" style="width:11px;margin: 0 5px;">')
    //         }
    //       },
    //       {
    //         type: 'menuitem',
    //         text: '火车',
    //         onAction: function () {
    //           editor.insertContent('<img src="http://signettours.cn/mob/static/images/trip/hc.png" style="width:18px;margin: 0 5px;">')
    //         }
    //       }
    //     ]
    //     callback(items)
    //   }
    // })
  }
}

export default {
  name: 'MaTinyMCE',
  components: {
    editor: Editor
  },
  model: {
    prop: 'editorData',
    event: 'editorChange'
  },
  props: {
    // 配置信息
    customConfig: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    // 初始值
    editorData: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      // 当前值
      content: this.editorData,
      config: defaultConfig
    }
  },
  mounted () {
    this.config = Object.assign(defaultConfig, this.customConfig)
  },
  methods: {
  },
  watch: {
    // eslint-disable-next-line
    content (val) {
      this.$emit('editorChange', this.content)
    }
  }
}
</script>
<style lang="less" scoped>
</style>
